var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53039 7.95163L6.12039 1.54163C5.88039 1.08163 5.36039 0.871631 4.96039 1.08163L1.40039 2.92163C1.00039 3.13163 0.880393 3.66163 1.13039 4.12163L5.21039 11.7916C5.45039 12.2516 5.97039 12.4616 6.37039 12.2516L7.84039 11.4916",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68039 10.7916C6.37039 10.3616 5.86039 10.1416 5.39039 10.2316L2.96039 5.66162",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5304 4.86164C2.8704 4.53164 2.9804 3.99164 2.8004 3.50164L4.6404 2.55164C4.9504 2.98164 5.4604 3.20164 5.9304 3.11164L8.33039 7.62164",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3004 7.88172C6.8804 7.58172 7.0504 6.80172 6.7004 6.13172C6.3504 5.46172 5.5904 5.16172 5.0204 5.46172C4.4504 5.76172 4.2704 6.54172 4.6204 7.21172C4.9704 7.88172 5.7304 8.18172 6.3004 7.88172Z",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12036 4.20161L4.48036 4.02161",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1804 12.2717C10.2904 12.3617 9.45043 11.9117 8.62043 11.0517C7.55043 9.9617 5.97043 9.5217 6.39043 8.8717C6.76043 8.2917 7.42043 8.4617 8.56043 8.9617C9.29043 9.2817 10.4504 8.9817 10.4104 8.3717",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86041 5.40163C9.51041 5.29163 10.8304 5.73163 12.3204 8.35163C12.4904 8.65163 12.6204 8.93163 12.7204 9.19163",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9904 13.9117L11.1704 13.2317C10.9504 13.0417 10.9104 12.7117 11.0904 12.4917L13.2104 9.93169C13.3904 9.71169 13.7204 9.68169 13.9504 9.87169L14.7704 10.5617",
    stroke: "current",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginFee);
export default __webpack_public_path__ + "static/media/marginFee.5f9715d1f0437a05b0b86316aacac4a3.svg";
export { ForwardRef as ReactComponent };